<template>
  <div class="footer-wrapper" :class="`layout-${layout}`">
    <div class="footer-content">
      <!-- 左侧：邮件订阅 -->
      <div class="footer-section mailing-list">
        <h2 class="footer-title font-apercu-bold">STAY IN THE DREAM</h2>
        <p class="footer-description font-apercu-medium">
          Be the first to hear about new collections, studio stories, and the occasional thing we couldn't help but share.
        </p>
        <div class="email-form font-apercu-medium">
          <input
            type="email"
            v-model="email"
            placeholder="Your Email Address"
            class="email-input font-apercu-medium"
            @keyup.enter="handleSubmit"
            :disabled="submitting"
          />
          <button class="submit-btn" @click="handleSubmit" :disabled="submitting">
            <span class="submit-text">{{ submitting ? 'Submitting...' : '[Submit]' }}</span>
          </button>
        </div>
        <!-- 内联提示消息（可根据项目需要替换为全局弹窗） -->
        <p v-if="message" class="message" :class="messageType">{{ message }}</p>
      </div>

      <!-- 右侧：联系信息 -->
      <div class="footer-section contact-info">
        <div class="info-column" style="display: flex; flex-direction: column; align-items: center;">
          <div style="text-align: left;">
            <div class="info-block" v-if="showGeneralEnquires">
              <h2 class="footer-title font-apercu-bold">GENERAL ENQUIRES</h2>
              <a :href="`mailto:${companyEmail}`" class="contact-link font-apercu-bold"
                style="display: block; margin-bottom: 5rem;">{{ companyEmail }}</a>
              <p class="contact-text font-apercu-medium">{{ companyPhone }}</p>
            </div>

            <div class="info-block" v-if="showInstagram" style="margin-top: 40rem;">
              <h2 class="footer-title font-apercu-bold">INSTAGRAM</h2>
              <a href="https://www.instagram.com/den_holm/" target="_blank" class="contact-link font-apercu-medium"
                style="display: block;text-decoration: none;">{{ instagram1 }}</a>
              <a href="https://www.instagram.com/den_holmunited/" target="_blank" class="contact-link font-apercu-medium"
                style="display: block;text-decoration: none;">{{ instagram2 }}</a>
            </div>
          </div>
        </div>

        <div class="info-column" v-if="showStudio" style="display: flex; justify-content: flex-end;">
          <div class="info-block">
            <h2 class="footer-title font-apercu-bold">STUDIO</h2>
            <p class="contact-text font-apercu-medium" style="max-width: 268rem;">
              {{ companyAddress }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部装饰 -->
    <div class="footer-decoration" v-if="showDecoration">
      <img :src="flowerLogo" alt="Flower Logo" class="flower-logo" />
    </div>
  </div>
</template>

<script>
import flowerLogo from '../assets/logo_tx.png'
import { getSiteConfig, subscribeEmail } from '@/api/content' // 请根据实际路径调整

export default {
  name: 'Footer',
  props: {
    // 布局类型：'contact' 或 'default' 或 'about'
    layout: {
      type: String,
      default: 'default'
    },
    // 是否显示通用查询
    showGeneralEnquires: {
      type: Boolean,
      default: true
    },
    // 是否显示Instagram
    showInstagram: {
      type: Boolean,
      default: false
    },
    // 是否显示Studio
    showStudio: {
      type: Boolean,
      default: true
    },
    // 是否显示装饰图标
    showDecoration: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      email: '',
      flowerLogo,
      companyEmail: 'info@den-holm.com',
      companyPhone: '+61 422 875 261',
      companyAddress: '12 Fulton Street, Oakleigh South 3167 Victoria, Australia',
      instagram1: '@den_holm',
      instagram2: '@den_holmunited',
      submitting: false,     // 防止重复提交
      message: '',           // 内联提示消息
      messageType: 'success' // 'success' 或 'error'
    }
  },
  mounted() {
    this.loadSiteConfig()
  },
  methods: {
    // 简单邮箱格式验证
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },

    // 处理订阅提交
    async handleSubmit() {
      // 清空之前的消息
      this.message = ''

      if (!this.email) {
        this.showFeedback('Please enter your email address.', 'error')
        return
      }

      if (!this.isValidEmail(this.email)) {
        this.showFeedback('Please enter a valid email address.', 'error')
        return
      }

      // 防止重复提交
      if (this.submitting) return
      this.submitting = true

      // try {
      //   // 调用订阅接口（假设 subscribeEmail 返回后端 result 字段，即布尔值）
      //   const result = await subscribeEmail(this.email)

      //   // 根据接口返回判断成功与否（后端 retCode === 1 时 result 为 true）
      //   if (result === true) {
      //     this.showFeedback('Subscription successful! Thank you for subscribing.', 'success')
      //     this.email = '' // 清空输入框
      //   } else {
      //     this.showFeedback('Subscription failed. Please try again later.', 'error')
      //   }
      // } catch (error) {
      //   // 网络错误或业务错误已在 axios 拦截器中统一弹窗，这里仅作兜底
      //   console.error('Subscription error:', error)
      //   this.showFeedback('An error occurred. Please try again.', 'error')
      // } finally {
      //   this.submitting = false
      // }
	  try {
	  	const response = await subscribeEmail(this.email); // 现在 response 是完整的 ReturnModel 对象
	  
	  	console.log(response)
	  	if (response && response.retCode === 1) {
	  		this.showFeedback('Subscription successful! Thank you for subscribing.', 'success')
	  		this.email = '';
	  	} else {
	  		this.showFeedback(response.retMsg || 'Subscription failed. Please try again later.', 'error')
	  	}
	  } catch (error) {
	  	console.error('Subscription error:', error);
	  	// 如果发生网络错误或非 2xx 状态码，会进入这里，错误信息已在拦截器的错误处理中显示
		this.showFeedback('An error occurred. Please try again.', 'error')
	  } finally {
	  	this.submitting = false;
	  }
    },

    // 显示反馈信息（可根据项目需要替换为全局弹窗）
    showFeedback(msg, type) {
      // 如果项目中有全局消息组件（如 Element UI 的 Message），可取消注释以下代码并删除内联逻辑
      // import { Message } from 'element-ui' 或 import { showMessage } from '@/config/message'
      // Message({ message: msg, type: type === 'success' ? 'success' : 'error' })
      // return

      // 使用内联消息
      this.message = msg
      this.messageType = type
      // 3秒后自动清除
      setTimeout(() => {
        this.message = ''
      }, 5000)
    },

    // 加载网站配置
    async loadSiteConfig() {
      try {
        const response = await getSiteConfig()
        const config = response && response.result ? response.result : null
        if (config) {
          this.companyEmail = config.CompanyEmail || this.companyEmail
          this.companyPhone = config.CompanyPhone || this.companyPhone
          this.companyAddress = config.CompanyAddress || this.companyAddress
          this.instagram1 = config.Instagram1 || this.instagram1
          this.instagram2 = config.Instagram2 || this.instagram2
        }
      } catch (error) {
        console.error('Failed to load site config:', error)
      }
    }
  }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.footer-wrapper {
  width: 100%;
  background: #fff;
}

.footer-content {
  padding: 40rem;
}

/* Contact页面布局 */
.footer-wrapper.layout-contact .footer-content {}

.footer-section {
  display: flex;
  flex-direction: column;
}

.mailing-list {
  max-width: 500rem;
}

.footer-title {
  font-size: 17rem;
  font-weight: 500;
  text-transform: uppercase;
  margin: 0 0 20rem 0;
  color: #000;
}

.footer-description {
  font-size: 14rem;
  line-height: 1.6;
  margin: 0 0 30rem 0;
  color: #333;
}

.email-form {
  display: flex;
  align-items: baseline;
  gap: 10rem;
  border-bottom: 1rem solid #000;
}

.email-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14rem;
  padding: 5rem 0;
  background: transparent;
  color: #000;
}

.email-input::placeholder {
  color: #000;
}

.submit-btn {
  background: none;
  border: none;
  font-size: 14rem;
  color: #000;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
  transition: opacity 0.3s;
}

.submit-btn:hover {
  opacity: 0.7;
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-text {
  font-weight: 500;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 40rem;
}

.contact-block {
  display: flex;
  justify-content: space-between;
  gap: 40rem;
}

.info-block {
  display: flex;
  flex-direction: column;
}

.contact-link {
  font-size: 14rem;
  color: #000;
  text-decoration: underline;
  transition: opacity 0.3s;
}

.contact-link:hover {
  opacity: 0.7;
}

.contact-text {
  font-size: 14rem;
  color: rgb(0, 0, 0, 1);
  margin: 0;
  line-height: 1.6;
}

.footer-decoration {
  text-align: center;
  margin-top: 60rem;
  padding-top: 40rem;
}

.flower-logo {
  width: 40rem;
  height: auto;
  opacity: 0.8;
}

/* Contact页面布局 */
.footer-wrapper.layout-contact .footer-content {}

/* About/Founder页面布局 */
.footer-wrapper.layout-about .footer-content {
  border-top: 2rem solid #000;
  margin-top: 0;
  height: auto;
  grid-template-columns: none;
  gap: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.footer-wrapper.layout-about .footer-section {
  float: left;
}

.footer-wrapper.layout-about .mailing-list {
  width: 30%;
}

.footer-wrapper.layout-about .contact-info {
  width: 60%;
  flex-direction: row;
  gap: 0;
  display: flex;
  justify-content: space-between;
}

.footer-wrapper.layout-about .info-column {
  width: 50%;
}

.footer-wrapper.layout-about .footer-decoration {
  text-align: right;
  margin: 40rem auto 0;
}

.footer-wrapper.layout-about .flower-logo {
  width: 32rem;
  margin-bottom: 24rem;
  margin-right: 40rem;
}

.footer-wrapper.layout-about .footer-title {
  font-size: 17rem;
  margin: 0 0 24rem 0;
}

.footer-wrapper.layout-about .footer-description {
  font-size: 16rem;
  margin: 0 0 40rem 0;
  color: #000;
  font-weight: 500;
}

.footer-wrapper.layout-about .email-form {
  border-bottom: 2rem solid #000;
}

.footer-wrapper.layout-about .email-input {
  font-size: 16rem;
  font-weight: 500;
}

.footer-wrapper.layout-about .email-input::placeholder {
  color: #000;
  font-weight: 500;
}

.footer-wrapper.layout-about .submit-btn {
  font-size: 16rem;
}

.footer-wrapper.layout-about .contact-link {
  font-size: 16rem;
  font-weight: 500;
}

.footer-wrapper.layout-about .contact-text {
  font-size: 16rem;
  color: rgb(0, 0, 0, 1);
  font-weight: 500;
}

/* 新增消息提示样式 */
.message {
  margin-top: 10rem;
  font-size: 14rem;
}
.message.success {
  color: #4caf50;
}
.message.error {
  color: #f44336;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-wrapper.layout-about .footer-content {
    flex-direction: column;
  }
  .footer-wrapper.layout-about .mailing-list,
  .footer-wrapper.layout-about .contact-info {
    width: 100%;
    float: none;
  }
  .footer-wrapper.layout-about .info-block {
    width: 100%;
    float: none;
    margin-bottom: 40rem;
  }
  .footer-wrapper.layout-about .contact-info {
    flex-direction: column;
    gap: 40rem;
  }
}
</style>